<header>
    <img src="logo_te.svg" title="TotalEnergies" alt="TotalEnergies" class="logo me-4 pointer" routerLink="/home"/>
    <div class="header-right">
        <div class="header-top">
            <div class="me-auto header-title">
                <div class="app-name me-3">
                    <img width="44" src="eva_logo.svg" title="EVA" alt="EVA" class="me-2 pointer"/>
                </div>
            </div>
            <div class="mat-form-field w-50">
                @if (canChangeUser() && isLoggedIn() && users().length > 1) {
                    <mat-select
                            class="user-select"
                            (selectionChange)="changeUser($event)"
                            panelClass="user-select-panel"
                    >
                        <mat-option *ngFor="let user of users()" [value]="user.igg">
                            {{ user.firstName }} {{ user.lastName }} | {{ getRoleLabel(user.role) | translate }}
                        </mat-option>
                    </mat-select>
                }
            </div>
            @if (user() && isLoggedIn()) {
                <ng-container class="header-badge-container">
                    <div class="header-badge user-badge" [matMenuTriggerFor]="userMenu">
                        <span class="display-name">{{ getUserDisplayName() }}</span>
                        <mat-icon color="primary" class="mb-1" svgIcon="total-user"></mat-icon>
                    </div>

                    <mat-menu #userMenu="matMenu" [overlapTrigger]="false" role="menu"
                              aria-label="{{ 'header.aria.menu_logout' | translate }}">
                        <button mat-menu-item [routerLink]="['/auth/logout']">
                            {{ 'general.main_menu.logout' | translate }}
                        </button>
                    </mat-menu>
                </ng-container>
            }
        </div>

        <div
                class="d-flex"
                [class.justify-content-end]="!isLoggedIn()"
                [class.justify-content-between]="isLoggedIn()"
        >
            @if (isLoggedIn()) {
                <app-navigation></app-navigation>
            }
            <div class="lang-dropdown" (click)="toggleDropdown()" (keyup)="toggleDropdown()" tabindex="0" role="button">
                <a class="lang-link" role="button" attr.aria-label="{{ 'header.aria.change_language'  | translate}}">
                    <mat-icon>language</mat-icon>
                    <span class="current-lang">{{ getCurrentLangLabel() }}</span>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </a>
                <div class="lang-options" [class.open]="isDropdownOpen()">
                    @for (lang of translate.getLangs(); track lang) {
                        <a
                                mat-list-item
                                (click)="switchLanguage(lang)"
                                (keyup)="switchLanguage(lang)"
                                role="button"
                                tabindex="0"
                                attr.aria-label="{{ 'header.aria.translate_to'  | translate: {lang: getLangLabel(lang)} }}"
                        >
                            {{ getLangLabel(lang) }}
                        </a>
                    }
                </div>
            </div>
        </div>

        <div (click)="nav?.toggle()" role="navigation" (keyup)="nav?.toggle()" class="burger-container" role="menu">
            <mat-icon class="burger menu" [ngClass]="{'active': !nav?.opened}">menu</mat-icon>
            <mat-icon class="burger close" [ngClass]="{'active': nav?.opened}">close</mat-icon>
        </div>
    </div>
</header>
